var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "infinite-scroll-container",
      on: { scroll: _vm.handleScroll },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading-indicator" }, [
            _vm._v("Chargement en cours..."),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }